import React from 'react';
import {Linking} from 'react-native';
import {Image} from '@rneui/themed';

import {useWebScreenDimensions} from '../../hooks/useWebScreenDimensions';
import {AirtableHomepageItem} from '../../models/airtable';

import { formatHeroImage } from './shared';

interface BannerProps {
  bannerItem?: AirtableHomepageItem;
}

const Banner: React.FC<BannerProps> = ({bannerItem}) => {
  if (!bannerItem) {
    return null;
  }

  const handlePress = async () => {
    if (
      bannerItem.pageLink &&
      (await Linking.canOpenURL(bannerItem.pageLink))
    ) {
      try {
        await Linking.openURL(bannerItem.pageLink);
      } catch (e) {
        console.log(e);
      }
    }
  };

  return <ResponsiveImage item={bannerItem} onPress={handlePress} />;
};

const ResponsiveImage = ({
  item,
  onPress,
}: {
  item: AirtableHomepageItem | undefined;
  onPress: any;
}) => {
  const {isWebDesktopScreen, platform} = useWebScreenDimensions();
  const src = formatHeroImage(item, isWebDesktopScreen);
  
  if (item?.platform && item.platform.length >= 1 && !item.platform.includes(platform)) {
    return null;
  }

  if (!src.uri) {
    console.warn(
      `AirtableHomepageItem.heroImage${isWebDesktopScreen && 'Web'} is empty`,
    );
    return null;
  }

  return (
    <Image
      onPress={onPress}
      source={src}
      containerStyle={{
        width: '100%',
        aspectRatio: !isWebDesktopScreen
          ? item?.heroImage?.width && item.heroImage.height
            ? item?.heroImage?.width / item?.heroImage?.height
            : 1.54
          : item?.heroImageWeb?.width && item.heroImageWeb.height
          ? item.heroImageWeb.width / item.heroImageWeb.height
          : 1.54,

        flex: 1,
        flexGrow: 1,
        borderRadius: 10,
        ...(isWebDesktopScreen
          ? {
              maxHeight: item?.heroImageWeb?.height,
            }
          : {}),
      }}
    />
  );
};

export default Banner;